/**
 * Les modules de dashboard qui n'ont aucun sens sur un GROUPE — décisions #27, #87.
 *
 * ## Pourquoi ce fichier existe, et pourquoi il est ici
 *
 * La liste vivait dans `pages/dashboard/modules/registry.ts`, que la frontière du
 * socle mobile interdit d'atteindre (#23). Or ce n'est pas un choix visuel du
 * dashboard web : c'est un **fait de domaine** — « ce module dérive des
 * réservations, et un groupe n'en a pas ». Les deux surfaces doivent en tirer la
 * même conclusion, donc il ne peut pas être écrit deux fois.
 *
 * Module **feuille** : aucun import, donc graphe transitif d'imports de valeur
 * vide — la contrainte que #74 pose sur ce que le mobile peut atteindre.
 *
 * ## Ce que la mesure a établi
 *
 * `reservations` est à **zéro sur les 19 groupes réels, depuis toujours**, et les
 * neuf modules ci-dessous en dérivent tous.
 *
 * ⚠️ Conséquence contre-intuitive, tranchée par #27 : **il n'y a rien à cacher**,
 * donc rien à remplacer. « Arrivées aujourd'hui : 0 » se lirait comme une
 * **mesure** alors que c'est une inapplicabilité — et la carte de repli est
 * disqualifiée par son propre libellé, « consultable sur ordinateur » étant faux
 * quand il n'y a rien à y consulter.
 *
 * Le mobile masque donc **au rendu**, sans rien mettre à la place.
 */
export const MODULES_MASQUES_EN_GROUPE: readonly string[] = [
    'arrivals',
    'arrivals_today',
    'departures',
    'departures_today',
    'guests_onsite',
    'kpis',
    'on_site',
    'reservation_search',
    'reservations',
];

/**
 * Ce module a-t-il un sens sur la sélection courante ?
 *
 * `estGroupe` est passé plutôt que lu : ce fichier ne doit dépendre de rien, et
 * c'est ce qui lui permet d'être atteint des deux côtés de la frontière.
 */
export function estModuleApplicable(type: string, estGroupe: boolean): boolean {
    return !estGroupe || !MODULES_MASQUES_EN_GROUPE.includes(type);
}
